<template>
  <div>
    <div></div>
    <div v-if="isIcon">
       <b-button
        v-if="m_note_id > 0"
        size="sm"
        variant="primary"
        @click="getNoteDetails(m_note_id)"
        class="btn-action"
        v-b-tooltip.hover
        :title="'Edit ' + (m_creditDebitNoteType == 2 ? 'Debit' : 'Credit') + ' Note'"
      >
        <i class="fa fa-pencil text-white"></i>
      </b-button>
    </div>
    <b-button
      v-else-if="m_note_id > 0"
      class="mb-1"
      @click="getNoteDetails(m_note_id)"
      size="xs"
      style="font-size: 0.675rem"
      :variant="m_creditDebitNoteType == 2 ? 'outline-success' : 'outline-danger'"
      >{{ m_creditDebitNoteType == 2 ? "Debit " : "Credit "
      }}{{ m_noteSeries }} Note</b-button
    >

    <!-- Added By Priyanshu SIngh Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="common-note-modal"
      hide-footer
      :title="m_title"
    >
      <b-row>
        <b-col cols="11" style="text-align: end">
          <b-form-checkbox
            v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'"
            v-model="isValidationRequired"
            class="mr-3"
            style="display: inline-block; vertical-align: middle;"
          >
            Enable Validation
          </b-form-checkbox>
          <b-button
            v-if="pdf_link != '' && m_approvalStatus == '1'"
            @click="PrintNote(JOB_NO, pdf_link)"
            size="sm"
            variant="warning"
            >PDF</b-button
          >
          <b-button @click="addContent" size="sm">
            Add Particulars
            <i class="fa fa-plus-circle ml-1"></i>
          </b-button>
        </b-col>
        <b-col cols="12 text-center">
          <span v-if="noteModal.creditcount >= 1 && noteModal.creditDebitNoteType == '1'">
            <span class="error">Credit Note No. :</span>
            {{ noteModal.creditnoteSeriesDetailsCount }}
          </span>
          <span v-if="noteModal.debitcount >= 1 && noteModal.creditDebitNoteType == '2'">
            <span class="error">DEBIT Note No. :</span>
            {{ noteModal.debitnoteSeriesDetailsCount }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" class="mt-2">
          <label for="blType">Type <span class="error" v-if="isValidationRequired">*</span></label>

          <model-list-select
            :list="agentTypeList"
            option-value="TypeVal"
            option-text="TypeTxt"
            v-model="noteModal.agentType"
            placeholder="Select Type"
            @input="getAgentConsigneeList(noteModal.agentType)"
          ></model-list-select>
          <span class="error" v-if="!noteModal.agentType">{{
            errorCDNote.agentType
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="blType">
            To
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <!-- {{getAllAgentColoaderList}} -->
          <!-- :list="$store.getters['common/getAllAgentColoaderList']" -->
          <model-list-select
            :list="
              getAllAgentColoaderList.length > 0
                ? getAllAgentColoaderList
                : this.$store.getters['common/getAllAgentColoaderList']
            "
            option-value="agentName"
            option-text="agentName"
            v-model="noteModal.AgentColoader"
            :placeholder="
              noteModal.agentType == 'Consignee'
                ? 'Select Consignee'
                : 'Select Agent/Coloader'
            "
            @input="getConsigneeAgentDetails"
          ></model-list-select>
          <span class="error" v-if="!noteModal.AgentColoader">{{
            errorCDNote.AgentColoader
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Consignee'">
          <label for="Consignee Address">
            Consignee Address
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.agentconsigneeAddress"
            type="text"
            placeholder="Enter Consignee Address"
          ></b-form-input>
          <span class="error" v-if="!noteModal.agentconsigneeAddress">{{
            errorCDNote.agentconsigneeAddress
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Agent'">
          <label for="Agent Country">
            Agent Country
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.agent_country"
            type="text"
            placeholder="Enter Agent Country"
          ></b-form-input>
          <span class="error" v-if="!noteModal.agent_country">{{
            errorCDNote.agent_country
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Vessel/Voy">
            Vessel/Voy
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.vesselVoy"
            type="text"
            placeholder="Enter Vessel Voy"
          ></b-form-input>
          <span class="error" v-if="!noteModal.vesselVoy">{{
            errorCDNote.vesselVoy
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="HBL/AWB">
            HBL/AWB
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.house_bl_no"
            type="text"
            placeholder="Enter HBL/AWB"
          ></b-form-input>
          <span class="error" v-if="!noteModal.house_bl_no">{{
            errorCDNote.house_bl_no
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="MBL/MAWB">
            MBL/MAWB
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.master_bl_no"
            type="text"
            placeholder="Enter MBL/MAWB"
          ></b-form-input>
          <span class="error" v-if="!noteModal.master_bl_no">{{
            errorCDNote.master_bl_no
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SHIPPER">
            SHIPPER
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.clientName"
            type="text"
            placeholder="Enter SHIPPER"
          ></b-form-input>
          <span class="error" v-if="!noteModal.clientName">{{
            errorCDNote.clientName
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="CONSIGNEE">
            CONSIGNEE
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.consignee"
            type="text"
            placeholder="Enter CONSIGNEE"
          ></b-form-input>
          <span class="error" v-if="!noteModal.consignee">{{
            errorCDNote.consignee
          }}</span>
        </b-col>

        <b-col cols="4" class="mt-2">
          <label for="Destination">
            Destination
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.FPOD"
            type="text"
            placeholder="Enter Destination"
          ></b-form-input>
          <span class="error" v-if="!noteModal.FPOD">{{ errorCDNote.FPOD }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Container No">
            Container No.
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            disabled
            :formatter="capitalizeAll"
            v-model="noteModal.containerNoArryNote"
            type="text"
            placeholder="Enter Container No"
          ></b-form-input>
          <span class="error" v-if="!noteModal.containerNoArryNote">{{
            errorCDNote.containerNoArryNote
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Container Type">
            Container Type
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            disabled
            :formatter="capitalizeAll"
            v-model="noteModal.containersTypes"
            type="text"
            placeholder="Enter Container Type."
          ></b-form-input>
          <span class="error" v-if="!noteModal.containersTypes">{{
            errorCDNote.containersTypes
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SHIPPER INV.">
            SHIPPER INV.
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.ShipperInvDet"
            type="text"
            placeholder="Enter SHIPPER INV. Details"
          ></b-form-input>
          <span class="error" v-if="!noteModal.ShipperInvDet">{{
            errorCDNote.ShipperInvDet
          }}</span>
        </b-col>
        <!-- <b-col cols="4" class="mt-2" v-if="(this.noteModal.page == 'fcl' || this.noteModal.page == 'consolidation')"> -->
        <b-col cols="4" class="mt-2">
          <label for="Booking No">
            Booking No
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.validBookingNo"
            type="text"
            placeholder="Enter Booking No"
          ></b-form-input>
          <span class="error" v-if="!noteModal.validBookingNo">{{
            errorCDNote.validBookingNo
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <!-- <b-col cols="4" class="mt-2" v-if="(this.noteModal.page == 'fcl' || this.noteModal.page == 'consolidation')"> -->
          <label for="SOB">
            SOB
            <span class="error" v-if="isValidationRequired">*</span>
          </label>

          <date-picker
            :format="selectDateFormat"
            lang="en"
            id="SOB"
            :minute-step="1"
            name="SOB"
            v-model="noteModal.SOB"
          ></date-picker>
          <span class="error" v-if="!noteModal.SOB">{{ errorCDNote.SOB }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <!-- <b-col cols="4" class="mt-2" v-if="(this.noteModal.page == 'fcl' || this.noteModal.page == 'consolidation')"> -->
          <label for="ETADest">
            ETA Dest
            <span class="error" v-if="isValidationRequired">*</span>
          </label>
          <date-picker
            :format="selectDateFormat"
            lang="en"
            id="ETADest"
            :minute-step="1"
            name="ETADest"
            v-model="noteModal.ETADest"
          ></date-picker>
          <span class="error" v-if="!noteModal.ETADest">{{ errorCDNote.ETADest }}</span>
        </b-col>
        <b-col cols="12">
          <label for="Remarks">Remarks</label>

          <b-form-textarea
            :formatter="capitalizeAll"
            v-model="noteModal.remarks"
            rows="3"
          ></b-form-textarea>
        </b-col>
        <b-col cols="12">
          <table class="table table-sm table-bordered mt-2">
            <tbody style="background: white">
              <tr v-if="noteParticulars.length > 0">
                <th scope="col" style="width: 5px">SN.</th>
                <th scope="col" style="width: 400px">Particulars</th>
                <th scope="col" style="width: 120px">QTY</th>
                <th scope="col" style="width: 180px">Amount</th>
                <th scope="col" style="width: 120px">Final</th>
                <th scope="col" style="width: 240px">Selected Cont</th>
                <th scope="col" style="width: 180px">Currency</th>
                <th scope="col" style="width: 5px">Actions</th>
              </tr>
              <tr v-for="(item, index) in noteParticulars" :key="index">
                <th scope="row">{{ index + 1 }}.</th>
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.parti"
                    placeholder="Enter Particular"
                  ></b-form-input>
                  <span class="error" v-if="item.parti_err">{{ item.parti_err }}</span>
                </td>
                <td>
                  <b-form-input
                    v-model="item.qty"
                    type="number"
                    min="0"
                    placeholder="QTY"
                    v-on:keyup="TotalAMT"
                  ></b-form-input>
                  <span class="error" v-if="item.qty_err">{{ item.qty_err }}</span>
                </td>
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.amt"
                    type="number"
                    placeholder="Enter Amount"
                    v-on:keyup="TotalAMT"
                  ></b-form-input>
                  <span class="error" v-if="item.amt_err">{{ item.amt_err }}</span>
                </td>
                <td>
                  <b>{{ item.final_amt || 0 }}</b>
                </td>
                <td>
                  <span>{{ item.container_selected || "-" }}</span>
                </td>
                <td>
                  <model-list-select
                    :list="$store.getters['common/getAllCurrencyList']"
                    v-model="item.currency"
                    option-value="currency_id"
                    option-text="currencyCode"
                    placeholder="Select Currency"
                  ></model-list-select>
                  <span class="error" v-if="item.currency_err">{{
                    item.currency_err
                  }}</span>
                </td>
                <td>
                  <b-button v-if="index > 0" size="sm" @click="removeParti(index)">
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                  </b-button>
                </td>
              </tr>
              <tr v-if="TotAMT != 0">
                <td colspan="4">
                  <b style="color: blue; font-weight: bold; font-size: 18px">Total</b>
                </td>
                <td colspan="4">
                  <b style="color: blue; font-weight: bold; font-size: 18px">{{
                    TotAMT
                  }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="12" class="text-center">
          <b-button
            :disabled="IsCDNotedisabled"
            class="mt-3"
            variant="success"
            v-if="noteParticulars.length > 0 && noteModal.AgentColoader"
            @click="submitNote"
          >
            <span v-if="IsCDNotedisabled">
              <b-spinner small class="mr-1"></b-spinner>Updating...
            </span>
            <span v-else>Update</span>
          </b-button>
          <b-button class="mt-3" variant="outline-danger" @click="hideNoteModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Added By Priyanshu SIngh End -->

    <!-- Assignment Summary Modal End -->
     <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    note_id: {
      type: String,
      default: "",
    },
    noteSeries: {
      type: String,
      default: "",
    },
    note_page: {
      type: String,
      default: "",
    },
    creditDebitNoteType: {
      type: String,
      default: "",
    },
    approvalStatus: {
      type: String,
      default: "",
    },
    uploadCreditDebit: {
      type: String,
      default: "",
    },
    creditDebitNote_Status: {
      type: String,
      default: "",
    },
    JOBID: {
      type: String,
      default: "",
    },
    JOBNO: {
      type: String,
      default: "",
    },
    JOBDATE: {
      type: String,
      default: "",
    },
    JOBTYPE: {
      type: String,
      default: "",
    },
    AgentType: {
      type: String,
      default: "",
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllConsigneeList",
      JSON.stringify({
        itemCode: "ConsigneeList",
      })
    );
    this.$store.dispatch(
      "common/setAllCurrencyList",
      JSON.stringify({ Currency: "Currency_DropDown" })
    );
    this.$store.dispatch(
      "common/setAllLedgerList",
      JSON.stringify({
        itemCode: "LedgerList",
      })
    );

    if (
      this.JOBID != "" &&
      this.Filter_Flag == true &&
      this.JOBNO &&
      this.JOBTYPE &&
      this.note_id &&
      this.creditDebitNoteType &&
      this.noteSeries &&
      this.note_page &&
      this.AgentType
    ) {
      this.getNoteDetails();
    }
  },

  data() {
    return {
      getNoteItem: {},
      m_title: this.title,
      m_note_id: this.note_id,
      m_noteSeries: this.noteSeries,
      m_note_page: this.note_page,
      m_creditDebitNoteType: this.creditDebitNoteType,
      m_approvalStatus: this.approvalStatus,
      pdf_link: this.uploadCreditDebit,
      m_creditDebitNote_Status: this.creditDebitNote_Status,

      JOB_ID: this.JOBID,
      JOB_NO: this.JOBNO,
      JOB_DATE: this.JOBDATE,
      JOB_TYPE: this.JOBTYPE,
      JOB_NO: this.JOBNO,
      Filter_Flag: false,

      TotAMT: 0,
      ManifestationParticulars: [],
      IsCDNotedisabled: false,
      NoteData: "",
      isValidationRequired: true,
      errorCDNote: {
        agentType: "",
        AgentColoader: "",
        vesselVoy: "",
        house_bl_no: "",
        master_bl_no: "",
        clientName: "",
        consignee: "",
        FPOD: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",
        validBookingNo: "",
        SOB: "",
        ETADest: "",
      },
      arrayErrorCDNote: [
        {
          agentType: "Please Select Type",
          AgentColoader: "Please Select To",
          vesselVoy: "Please Enter Vessel/Voy ",
          house_bl_no: "Please Enter HBL/AWB",
          master_bl_no: "Please Enter MBL/MAWB",
          clientName: "Please ENter SHIPPER",
          consignee: "Please Enter Consignee",
          FPOD: "Please Enter FPOD",
          containerNoArryNote: "Please Enter Container No.",
          containersTypes: "Please Enter Container Type",
          ShipperInvDet: "Please Enter SHIPPER INV",
          validBookingNo: "Please Enter Booking No",
          SOB: "Please Enter SOB",
          ETADest: "Please Enter ETA Destination",
        },
      ],
      selectDateFormat,
      allModuleId: "",
      ShowSendApproval: "",
      AgentColoaderList: [],
      noteParticulars: [],
      CurrencyList: [],
      containerTypeDetailFactory: [],
      getCLientData: ["gfdg"],
      getAllAgentColoaderList: [],
      agentTypeList: [
        {
          TypeVal: "Consignee",
          TypeTxt: "Consignee",
        },
        {
          TypeVal: "Agent",
          TypeTxt: "Agent",
        },
      ],
      noteModal: {
        agentType: this.AgentType,
        agent_country: "",
        fk_agent_id: "",
        fk_consignee_id: "",
        agentconsigneeAddress: "",
        shipper: "",
        branchName: "",
        branchList: [],
        AgentColoader: "",
        creditDebitNoteType: "",
        remarks: "",
        noteDate: "",
        note_id: this.note_id,
        noteContent: "",
        noteAmount: "",
        noteCurrency: "",
        ffExportFclId: "",
        allModuleId: "",
        fclBlId: "",
        BLNumber: "",
        uploadCreditDebit: "",
        sentForApproval: "",
        approvalStatus: "",
        masterorLinerBlNo: "",
        type: "",

        vesselVoy: "",
        house_bl_no: "",
        master_bl_no: "",
        clientName: "",
        consignee: "",
        FPOD: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",
        validBookingNo: "",
        SOB: "",
        ETADest: "",
      },
      docURL: URL_BASE_DOC,
      validate: false,
      alert: {
        content: "Alert Message",
        ok: "OK",
      },
      isSubmittingNote: false,
      //Added By Priyanshu SIngh End
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {
    capitalizedText() {
      // Ensure originalText is not empty before capitalizing
      if (this.title) {
        return this.title.charAt(0).toUpperCase() + this.title.slice(1);
      } else {
        return this.m_title;
      }
    },
  },
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
    isValidationRequired(newVal) {
      if (!newVal) {
        // Clear all validation errors when validation is disabled
        this.errorCDNote = {
          agentType: "",
          AgentColoader: "",
          vesselVoy: "",
          house_bl_no: "",
          master_bl_no: "",
          clientName: "",
          consignee: "",
          FPOD: "",
          containerNoArryNote: "",
          containersTypes: "",
          ShipperInvDet: "",
          validBookingNo: "",
          SOB: "",
          ETADest: "",
        };
        this.noteParticulars.forEach((item) => {
          item.parti_err = "";
          item.qty_err = "";
          item.amt_err = "";
          item.currency_err = "";
        });
      }
    },
  },
  methods: {
    getNoteDetails() {
      this.Filter_Flag = true;
      this.getCRDR();
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      );
      this.$store.dispatch(
        "common/setAllLedgerList",
        JSON.stringify({
          itemCode: "LedgerList",
        })
      );
      this.$store.dispatch("common/setAllAgentColoaderList");
    },
    removeTags(str) {
      if (str === null || str === "") return false;
      else str = str.toString();
      return str.replace(/(<([^>]+)>)/gi, "");
    },
    validateAddManifestationDetail() {
      let validate_new = true;
      let MainARR = this.noteParticulars;
      for (let j = 0; j < MainARR.length; j++) {
        const row = this.noteParticulars[j];
        const qtyNum = Number(row.qty);
        const amtNum = Number(row.amt);
        const finalAmt = qtyNum * amtNum;
        row.parti_err = !row.parti || !String(row.parti).trim() ? "Please Enter Particular" : "";
        row.qty_err =
          row.qty === "" || row.qty === null || row.qty === undefined || qtyNum <= 0
            ? "Please Enter Quantity"
            : "";
        row.amt_err =
          row.amt === "" || row.amt === null || row.amt === undefined || amtNum <= 0
            ? "Please Enter Amount"
            : "";
        if (!row.qty_err && !row.amt_err && finalAmt <= 0) {
          row.amt_err = "Final Amount must be greater than 0";
        }
        row.currency_err = !row.currency ? "Please Enter Currency" : "";

        if (row.parti_err || row.qty_err || row.amt_err || row.currency_err) {
          validate_new = false;
        }
      }
      // console.log("this.noteParticulars=>", this.noteParticulars);
      this.validate = validate_new;
    },
    getAgentConsigneeList(agentType) {
      this.noteModal.AgentColoader = "";
      if (agentType == "Agent") {
        this.getAllAgentColoaderList = this.$store.getters[
          "common/getAllAgentColoaderList"
        ];
      } else if (agentType == "Consignee") {
        this.getAllAgentColoaderList = this.$store.getters["common/getAllConsigneeList"];
      }
      this.noteModal.AgentColoader = "";
      console.log("AgentColoader Details=>", this.noteModal.AgentColoader);
    },
    getConsigneeAgentDetails() {
      this.noteModal.fk_consignee_id = "";
      this.noteModal.fk_agent_id = "";
      this.noteModal.agent_country = "";
      this.noteModal.agentconsigneeAddress = "";
      if (this.noteModal.agentType == "Consignee") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.noteModal.AgentColoader) {
            console.log("Consignee Details=>", val);
            this.noteModal.fk_consignee_id = val.agntColoaderId;
            this.noteModal.agentconsigneeAddress = val.address;
            this.noteModal.agentAddress = val.address;
          }
        });
      } else if (this.noteModal.agentType == "Agent") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.noteModal.AgentColoader) {
            console.log("Agent Details=>", val);
            this.noteModal.fk_agent_id = val.agntColoaderId;
            this.noteModal.agentconsigneeAddress = val.address;
            this.noteModal.agentAddress = val.address;
            this.noteModal.agent_country=val.countryName;
          }
        });
      }
    },
    submitNote() {
      if (this.isSubmittingNote) return false;
      if (this.isValidationRequired) {
        this.validateCDNote();
        // if (this.validate == false) return false;
        this.validateAddManifestationDetail();

        console.log("this.noteModal=>", this.noteModal);
        console.log("this.errorCDNote=>", this.errorCDNote);
        console.log("this.noteParticulars=>", this.noteParticulars);
        if (this.validate == false) return false;
      }else{
        this.validate=true;
      }

      this.isLoading = true;
      this.isSubmittingNote = true;
      this.ShowSendApproval = false;

      if (this.noteParticulars.length <= 0) {
        this.isSubmittingNote = false;
        this.alert.content = "Please add particulars";
        this.$refs["addPop"].open();
        return false;
      }

      let noteParti = [];
      let noteAmt = [];
      let noteCurrency = [];
      this.noteModal["fk_currency_id"] = "";
      for (let i = 0; i < this.noteParticulars.length; i++) {
        noteParti.push(this.noteParticulars[i].parti);
        const finalAmount = Number(this.noteParticulars[i].final_amt);
        noteAmt.push(Number.isFinite(finalAmount) ? finalAmount : 0);
        noteCurrency.push(
          this.noteParticulars[i].currency ? this.noteParticulars[i].currency : 0
        );
        this.noteModal["fk_currency_id"] = this.noteParticulars[i].currency
          ? this.noteParticulars[i].currency
          : "1";
      }
      this.noteModal.noteContent = noteParti.toString();
      this.noteModal.noteAmount = noteAmt.toString();
      this.noteModal.noteCurrency = noteCurrency.toString();

      this.noteModal["containerNoArryNote"] = this.noteModal.containerNoArryNote;
      this.noteModal["containerTypesArr"] = this.noteModal.containersTypes;
      this.noteModal["ShipperInvDet"] =
        this.noteModal.ShipperInvDet == undefined ? "" : this.noteModal.ShipperInvDet;
      this.noteModal["type"] = this.noteModal.type;
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = this.noteModal.allModuleId;
      this.noteModal["agentName"] = this.noteModal.AgentColoader;
      this.noteModal["overseas_agent"] = this.noteModal.AgentColoader;
      this.noteModal["agentAddress"] = this.noteModal.agentAddress;
      this.noteModal["vesselVoy"] = this.noteModal.vesselVoy;
      this.noteModal["shipper"] =
        this.noteModal.clientName == undefined ? "" : this.noteModal.clientName;
      this.noteModal["consignee"] =
        this.noteModal.consignee == undefined ? "" : this.noteModal.consignee;
      this.noteModal["fclBlId"] = 0;
      this.noteModal["branchName"] = this.noteModal.branchName;
      this.noteModal["FinalPlace"] = this.noteModal.FPOD
        ? this.noteModal.FPOD
        : this.noteModal.FinalPlace;

      this.noteModal["master_bl_no"] =
        this.noteModal.master_bl_no == undefined
          ? this.noteModal.MBLNO
          : this.noteModal.master_bl_no;
      this.noteModal["house_bl_no"] =
        this.noteModal.house_bl_no == undefined
          ? this.noteModal.HBLNO
          : this.noteModal.house_bl_no;
      this.noteModal["masterorLinerBlNo"] =
        this.noteModal.master_bl_no == undefined
          ? this.noteModal.MBLNO
          : this.noteModal.master_bl_no;
      this.noteModal["BLNumber"] =
        this.noteModal.house_bl_no == undefined
          ? this.noteModal.HBLNO
          : this.noteModal.house_bl_no;
      this.noteModal["page"] = this.noteModal.page;
      this.noteModal["salesSeries"] = this.noteModal.salesSeries;
      this.noteModal["salesSeriesUpload"] = this.noteModal.salesSeries.replaceAll(
        "/",
        "_"
      );
      this.noteModal["ffExportFclId"] = this.noteModal.ffExportFclId;
      this.noteModal["LPM"] = this.noteModal.LPM;
      this.noteModal["PODM"] = this.noteModal.PODM;
      this.noteModal["PORM"] = this.noteModal.PORM;
      this.noteModal["clientNameM"] = this.noteModal.clientNameM;
      this.noteModal["shippingLineM"] = this.noteModal.shippingLineM;
      this.noteModal["ASeriesM"] = this.noteModal.ASeriesM;
      this.noteModal["agentNameM"] = this.noteModal.agentNameM;
      this.noteModal["overseas_agentM"] = this.noteModal.overseas_agentM;
      this.noteModal["ASDateM"] = this.noteModal.ASDateM;
      this.noteModal["ToM"] = this.noteModal.AgentColoader;
      if (this.noteModal["vesselVoy"] == undefined) {
        this.noteModal["vesselVoy"] = "";
      }

      if (this.noteModal["fclBlId"] == undefined) {
        this.noteModal["fclBlId"] = "0";
      }

      if (this.noteModal["agentAddress"] == undefined) {
        this.noteModal["agentAddress"] = "";
      }

      if (this.noteModal["BLNumber"] == "NaN") {
        this.noteModal["BLNumber"] = "";
      }

      this.noteModal["validBookingNo"] = this.noteModal.validBookingNo;
      this.noteModal["SOB"] = this.noteModal.SOB;
      this.noteModal["ETADest"] = this.noteModal.ETADest;
      this.IsCDNotedisabled = true;
      // return false;

      if (this.validate != false) {
        console.log(this.noteModal);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addCreditDebitNoteNew_VP.php`,
          data: JSON.stringify(this.noteModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // Always close immediately on successful API response.
              this.$refs["common-note-modal"].hide();

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.IsCDNotedisabled = false;

              Object.keys(this.noteModal).map((x) => {
                this.noteModal[x] = "";
              });
              this.noteParticulars = [];
              this.$refs["addPop"].open();
              // this.getData();
              this.viewFFExportFCL("0", "0", "1", "1");
            }
          })
          .catch((error) => {})
          .finally(() => {
            this.isSubmittingNote = false;
            this.IsCDNotedisabled = false;
            this.isLoading = false;
          });
      }
    },
    TotalAMT() {
      let TotAmount = 0;
      this.noteParticulars.forEach((item) => {
        const qty = Number(item.qty || 0);
        const amount = Number(item.amt || 0);
        const finalAmt = qty * amount;
        item.final_amt = Number.isFinite(finalAmt) ? finalAmt : 0;
        TotAmount += item.final_amt;
      });
      this.TotAMT = Number(TotAmount.toFixed(2));
      this.$forceUpdate();
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.CurrencyList = [];
        let payload = {
          Currency: "Currency_DropDown",
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/viewAllCurrencyList.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.CurrencyList.length > 0) {
                this.CurrencyList = data.CurrencyList;
              } else {
                this.CurrencyList = [];
              }
              return resolve(this.CurrencyList);
            }
          })
          .catch((error) => {});
      });
    },
    hideNoteModal() {
      this.noteModal.approvalStatus = "";
      this.noteModal.sentForApproval = "";
      this.noteContent = "";
      this.noteAmount = "";
      this.noteCurrency = "";
      // this.m_note_id = "";
      this.noteModal.remarks = "";
      this.noteParticulars = [];
      this.TotAMT = 0;
      this.$refs["common-note-modal"].hide();
      this.isLoading = false;
    },

    addContent() {
      let obj = {
        parti: "",
        qty: "1",
        amt: "",
        final_amt: 0,
        container_selected: "",
        amt_err: "",
        parti_err: "",
        qty_err: "",
        currency_err: "",
        currency: "1",
      };
      this.noteParticulars.push(obj);
    },
    removeParti(index) {
      this.noteParticulars.splice(index, 1);
      this.TotalAMT();
    },
    validateCDNote() {
      if (!this.isValidationRequired) {
        this.validate = true;
        return;
      }
      let validate_new = true;

      this.errorCDNote = {
        agentType: "",
        AgentColoader: "",
        vesselVoy: "",
        house_bl_no: "",
        master_bl_no: "",
        clientName: "",
        consignee: "",
        FPOD: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",
      };
      // if (this.noteModal.page == "fcl" || this.noteModal.page == "consolidation") {
      //   this.errorCDNote.validBookingNo = "";
      //   this.errorCDNote.SOB = "";
      //   this.errorCDNote.ETADest = "";
      // }
      Object.keys(this.errorCDNote).map((x, index) => {
        if (
          this.noteModal[x] == "" ||
          this.noteModal[x] == undefined ||
          this.noteModal[x] == null
        ) {
          this.errorCDNote[x] = this.arrayErrorCDNote[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    PrintNote(ffExportFclSeries, uploadCreditDebit) {
      if (!uploadCreditDebit) return
      const jobNo = ffExportFclSeries || ''
      const key = this.getFormattedDocUrl(uploadCreditDebit, jobNo)
      this.openSignedDocument(key)
    },
    async getCRDR() {
      if (this.AgentType != undefined && this.AgentType != null && this.AgentType != "") {
        await this.getAgentConsigneeList(this.AgentType);
      }
      this.$refs["common-note-modal"].show();
      if (this.Filter_Flag == true) {
        let payload = {
          itemCode: "getNoteItem",
          note_id: this.m_note_id,
          note_no: this.m_noteSeries,
          allModuleId: this.JOB_ID,
          page: this.m_note_page,
        };
        CommonService.getCheckBLDetails(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.getNoteItem) {
                this.getNoteItem = data.getNoteItem;
                this.noteParticulars = this.getNoteItem.noteParticulars
                  ? JSON.parse(this.getNoteItem.noteParticulars)
                  : [];
                this.noteParticulars = this.noteParticulars.map((item) =>
                  Object.assign({}, item, {
                    qty: item.qty != null && item.qty !== "" ? String(item.qty) : "1",
                    amt: item.amt != null && item.amt !== "" ? String(item.amt) : "0",
                    final_amt:
                      item.final_amt != null && item.final_amt !== ""
                        ? Number(item.final_amt)
                        : 0,
                    container_selected: item.container_selected || "",
                    amt_err: item.amt_err || "",
                    parti_err: item.parti_err || "",
                    currency_err: item.currency_err || "",
                    currency: item.currency || "1",
                  })
                );
                this.noteModal = {
                  fk_currency_id: this.getNoteItem.fk_currency_id,
                  noteContent: this.getNoteItem.noteContent,
                  noteAmount: this.getNoteItem.noteAmount,
                  noteCurrency: this.getNoteItem.noteCurrency,
                  containerNoArryNote: this.getNoteItem.containerNoArryNote,
                  containersTypes: this.getNoteItem.containerTypesArr,
                  ShipperInvDet: this.getNoteItem.ShipperInvDet,
                  type: this.getNoteItem.type,
                  noteParticulars: this.getNoteItem.noteParticulars,
                  allModuleId: this.getNoteItem.allModuleId,
                  agentName: this.getNoteItem.AgentColoader,
                  overseas_agent: this.getNoteItem.AgentColoader,
                  agentAddress: this.getNoteItem.agentAddress,
                  vesselVoy: this.getNoteItem.vesselVoy,
                  shipper: this.getNoteItem.shipper,
                  clientName: this.getNoteItem.shipper,
                  consignee: this.getNoteItem.consignee,
                  fclBlId: this.getNoteItem.fclBlId,
                  branchName: this.getNoteItem.branchName,
                  FinalPlace: this.getNoteItem.FinalPlace,
                  FPOD: this.getNoteItem.FinalPlace,
                  master_bl_no: this.getNoteItem.masterorLinerBlNo,
                  house_bl_no: this.getNoteItem.BLNumber,
                  masterorLinerBlNo: this.getNoteItem.masterorLinerBlNo,
                  BLNumber: this.getNoteItem.BLNumber,
                  MBLNO: this.getNoteItem.MBLNO,
                  HBLNO: this.getNoteItem.HBLNO,
                  page: this.getNoteItem.page,
                  salesSeries: this.getNoteItem.salesSeries,
                  salesSeriesUpload: this.getNoteItem.salesSeries.replaceAll("/", "_"),
                  ffExportFclId: this.getNoteItem.ffExportFclId,

                  LPM: this.getNoteItem.LPM,
                  PODM: this.getNoteItem.PODM,
                  PORM: this.getNoteItem.PORM,
                  FPOD: this.getNoteItem.FPOD,
                  clientNameM: this.getNoteItem.clientNameM,
                  shippingLineM: this.getNoteItem.shippingLineM,
                  ASeriesM: this.getNoteItem.salesSeries,
                  agentNameM: this.getNoteItem.AgentColoader,
                  overseas_agentM: this.getNoteItem.AgentColoader,
                  ASDateM: this.getNoteItem.assDate,
                  ToM: this.getNoteItem.AgentColoader,

                  agentType: this.getNoteItem.agentType,
                  fk_agent_id: this.getNoteItem.fk_agent_id,
                  fk_consignee_id: this.getNoteItem.fk_consignee_id,
                  agentconsigneeAddress: this.getNoteItem.agentconsigneeAddress,

                  AgentColoader: this.getNoteItem.AgentColoader,
                  creditDebitNoteType: this.getNoteItem.creditDebitNoteType,
                  remarks: this.getNoteItem.remarks,
                  noteDate: this.getNoteItem.noteDate,
                  note_id: this.getNoteItem.note_id,

                  uploadCreditDebit: this.getNoteItem.uploadCreditDebit,
                  sentForApproval: this.getNoteItem.sentForApproval,
                  approvalStatus: this.getNoteItem.approvalStatus,

                  FPOD: this.getNoteItem.FinalPlace,
                  validBookingNo: this.getNoteItem.validBookingNo,
                  SOB: this.getNoteItem.SOB,
                  ETADest: this.getNoteItem.ETADest,
                };

                if (this.noteParticulars.length > 0) {
                  this.TotalAMT();
                }
                this.getConsigneeAgentDetails();
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on All_BL_List Error: ", error);
          });
      }
    },
    getNatureOfExpense(item) {
      if (item.nature_of_expense) return item.nature_of_expense
      if (item.nature_of_expense_relation && item.nature_of_expense_relation.nature_name) {
        return item.nature_of_expense_relation.nature_name
      }
      return null
    },
    getFormattedDocUrl(urlOrKey, manualJobNo) {
      if (!urlOrKey) return ''

      // 1. Strip any query parameters if present
      let cleanPath = urlOrKey.split('?')[0]

      // 2. Extract key from full URL if it contains ASSIGNMENT_UPLOADS
      if (cleanPath.includes('ASSIGNMENT_UPLOADS/')) {
        const parts = cleanPath.split('ASSIGNMENT_UPLOADS/')
        return 'ASSIGNMENT_UPLOADS/' + parts[parts.length - 1]
      }

      // 3. For raw filenames, build the path
      if (!cleanPath.startsWith('http') && !cleanPath.includes('/')) {
        const jobNo = manualJobNo || this.JOB_NO || ''
        if (jobNo) {
          const folderJobNo = jobNo.replaceAll('/', '_')
          const fileDoc = cleanPath.replaceAll('/', '_')
          return `ASSIGNMENT_UPLOADS/${folderJobNo}/${fileDoc}`
        }
      }

      return cleanPath
    },
  },
}
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// editCRDRNote.vue?917aa2b2